interface Language {
  id: string;
  name: string;
  hello: string;
  thankYou: string;
  flagEmoji: string;
  color: string;
}

export const languages: Language[] = [
  {
    id: "fr",
    name: "Français",
    hello: "Bonjour",
    thankYou: "Merci",
    flagEmoji: "🇫🇷",
    color: "#002D62",
  },
  {
    id: "en",
    name: "English",
    hello: "Hello",
    thankYou: "Thank you",
    flagEmoji: "🇬🇧",
    color: "#00AEEF",
  },
  {
    id: "es",
    name: "Español",
    hello: "Hola",
    thankYou: "Gracias",
    flagEmoji: "🇪🇸",
    color: "#F1BF00",
  },
  {
    id: "de",
    name: "Deutsch",
    hello: "Hallo",
    thankYou: "Danke",
    flagEmoji: "🇩🇪",
    color: "#DD0000",
  },
  {
    id: "it",
    name: "Italiano",
    hello: "Ciao",
    thankYou: "Grazie",
    flagEmoji: "🇮🇹", 
    color: "#008C45",
  },
  {
    id: "pt",
    name: "Português",
    hello: "Olá",
    thankYou: "Obrigado",
    flagEmoji: "🇵🇹",
    color: "#006600",
  },
  {
    id: "ru",
    name: "Русский",
    hello: "Привет",
    thankYou: "Спасибо",
    flagEmoji: "🇷🇺",
    color: "#0039A6",
  },
  {
    id: "zh",
    name: "中文",
    hello: "你好",
    thankYou: "谢谢",
    flagEmoji: "🇨🇳",
    color: "#DE2910",
  },
  {
    id: "ja",
    name: "日本語",
    hello: "こんにちは",
    thankYou: "ありがとう",
    flagEmoji: "🇯🇵",
    color: "#BC002D",
  },
  {
    id: "ar",
    name: "العربية",
    hello: "مرحبا",
    thankYou: "شكرا",
    flagEmoji: "🇸🇦",
    color: "#006C35",
  },
];
